var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-full h-full min-h-full "},[_c('AppHeader'),_c('div',{staticClass:"flex flex-grow overflow-hidden"},[_c('AppAside'),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }